// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"100":"9149163e","486":"08587bc7"}[chunkId] + ".chunk.css";
};